import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** shadcn's own helper, verbatim shape: last conflicting Tailwind class wins instead of both applying. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
